import type { RunSummary } from "./types.js";

type NurtureLead = Pick<RunSummary, "address" | "sellerName">;

export function buildNurtureMessage(run: NurtureLead): string {
  const firstName = run.sellerName?.trim().split(/\s+/)[0] || "there";
  const street = run.address.split(",")[0]?.trim() || "the property";
  return `Hi ${firstName}, I'm Hope, an automated assistant with Middle America Homes, checking back about ${street}. Are you still open to talking about selling? Reply STOP to opt out.`;
}
